module.exports = __webpack_public_path__ + "img/LinkedIn-Icon.4edaeb7d.png";